import { EligibilityType } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/shared/enums.pb';
import { InsuranceDetailQueries } from '@frontend/api-insurance-detail';
import { useGetLocationVerticalForPayerList } from './use-get-location-vertical-for-payer-list';

type UseGetPayersListParams = {
  locationId: string;
  isEnhancedInsuranceVerificationEnabled: boolean;
  enabled?: boolean;
};

export const useGetPayersList = ({
  locationId,
  isEnhancedInsuranceVerificationEnabled,
  enabled = true,
}: UseGetPayersListParams) => {
  const { locationVerticalForPayerList } = useGetLocationVerticalForPayerList(locationId || '');

  const payerListQuery = InsuranceDetailQueries.useGetPayerList({
    locationId: locationId || '',
    vertical: locationVerticalForPayerList,
    eligibilityType: isEnhancedInsuranceVerificationEnabled ? EligibilityType.ENHANCED : EligibilityType.LITE,
    options: {
      enabled: !!locationId && enabled,
    },
  });

  return payerListQuery;
};
